import globals from "../../styles/globals.scss";

export const OrdersIcon = ({ color = "#4C4C4C" }) => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.29231 4.50015C8.71006 4.50015 9.04615 4.83453 9.04615 5.25017C9.04615 5.66581 8.71006 6.0002 8.29231 6.0002H3.76923C3.35147 6.0002 3.01538 5.66581 3.01538 5.25017C3.01538 4.83453 3.35147 4.50015 3.76923 4.50015H8.29231ZM8.29231 10.0003C8.71006 10.0003 9.04615 10.3347 9.04615 10.7504C9.04615 11.166 8.71006 11.5004 8.29231 11.5004H3.76923C3.35147 11.5004 3.01538 11.166 3.01538 10.7504C3.01538 10.3347 3.35147 10.0003 3.76923 10.0003H8.29231ZM3.01538 8.00026C3.01538 7.58462 3.35147 7.25024 3.76923 7.25024H8.29231C8.71006 7.25024 9.04615 7.58462 9.04615 8.00026C9.04615 8.4159 8.71006 8.75029 8.29231 8.75029H3.76923C3.35147 8.75029 3.01538 8.4159 3.01538 8.00026ZM2.51282 1.26223L3.78179 0.180568C4.06449 -0.0601895 4.4791 -0.0601895 4.76179 0.180568L6.03077 1.26223L7.29974 0.180568C7.58244 -0.0601895 7.99705 -0.0601895 8.27974 0.180568L9.54872 1.26223L10.8177 0.180568C11.0407 -0.0100441 11.3548 -0.0537518 11.6218 0.0686273C11.8888 0.191038 12.0615 0.457202 12.0615 0.750025V15.2505C12.0615 15.5443 11.8888 15.8099 11.6218 15.9318C11.3548 16.0537 11.0407 16.0099 10.8177 15.8193L9.54872 14.738L8.27974 15.8193C7.99705 16.0599 7.58244 16.0599 7.29974 15.8193L6.03077 14.738L4.76179 15.8193C4.4791 16.0599 4.06449 16.0599 3.78179 15.8193L2.51282 14.738L1.24447 15.8193C1.02083 16.0099 0.706417 16.0537 0.438801 15.9318C0.171374 15.8099 0 15.5443 0 15.2505V0.750025C0 0.457202 0.171374 0.191006 0.438801 0.0686273C0.706417 -0.0537518 1.02083 -0.0100441 1.24447 0.180568L2.51282 1.26223ZM2.02219 13.1817C2.30457 12.941 2.72107 12.941 3.00345 13.1817L4.27179 14.263L5.54077 13.1817C5.82346 12.941 6.23808 12.941 6.52077 13.1817L7.78974 14.263L9.05872 13.1817C9.34141 12.941 9.75603 12.941 10.0387 13.1817L10.5538 13.6192V2.3807L10.0387 2.81947C9.75603 3.06041 9.34141 3.06041 9.05872 2.81947L7.78974 1.73787L6.52077 2.81947C6.23808 3.06041 5.82346 3.06041 5.54077 2.81947L4.27179 1.73787L3.00345 2.81947C2.72107 3.06041 2.30457 3.06041 2.02219 2.81947L1.50769 2.3807V13.6192L2.02219 13.1817Z"
        fill={color}
      />
    </svg>
  );
};

export const SettingsIcon = ({ color = "#4C4C4C" }) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.46154 0C2.87077 0 3.2 0.335938 3.2 0.75V2.61438C4.2 2.93313 4.92308 3.88125 4.92308 5C4.92308 6.11875 4.2 7.06563 3.2 7.38438V15.25C3.2 15.6656 2.87077 16 2.46154 16C2.05385 16 1.72308 15.6656 1.72308 15.25V7.38438C0.724308 7.06563 0 6.11875 0 5C0 3.88125 0.724308 2.93313 1.72308 2.61438V0.75C1.72308 0.335938 2.05385 0 2.46154 0ZM2.46154 6C3.00615 6 3.44615 5.55313 3.44615 5C3.44615 4.44687 3.00615 4 2.46154 4C1.91785 4 1.47692 4.44687 1.47692 5C1.47692 5.55313 1.91785 6 2.46154 6ZM9.84615 11C9.84615 12.1187 9.12308 13.0656 8.12308 13.3844V15.25C8.12308 15.6656 7.79385 16 7.38462 16C6.97538 16 6.64615 15.6656 6.64615 15.25V13.3844C5.64615 13.0656 4.92308 12.1187 4.92308 11C4.92308 9.88125 5.64615 8.93438 6.64615 8.61563V0.75C6.64615 0.335938 6.97538 0 7.38462 0C7.79385 0 8.12308 0.335938 8.12308 0.75V8.61563C9.12308 8.93438 9.84615 9.88125 9.84615 11ZM7.38462 12C7.92923 12 8.36923 11.5531 8.36923 11C8.36923 10.4469 7.92923 10 7.38462 10C6.84 10 6.4 10.4469 6.4 11C6.4 11.5531 6.84 12 7.38462 12ZM13.0462 15.25C13.0462 15.6656 12.7169 16 12.3077 16C11.8985 16 11.5692 15.6656 11.5692 15.25V8.38437C10.5692 8.06562 9.84615 7.11875 9.84615 6C9.84615 4.88125 10.5692 3.93437 11.5692 3.61562V0.75C11.5692 0.335938 11.8985 0 12.3077 0C12.7169 0 13.0462 0.335938 13.0462 0.75V3.61562C14.0462 3.93437 14.7692 4.88125 14.7692 6C14.7692 7.11875 14.0462 8.06562 13.0462 8.38437V15.25ZM12.3077 5C11.7631 5 11.3231 5.44687 11.3231 6C11.3231 6.55313 11.7631 7 12.3077 7C12.8523 7 13.2923 6.55313 13.2923 6C13.2923 5.44687 12.8523 5 12.3077 5Z"
        fill={color}
      />
    </svg>
  );
};

export const PuzzleIcon = ({ color = "#4C4C4C" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2812 5.6875C13.1867 5.6875 13.0928 5.69299 13 5.70373V5.3125C13 3.95 11.65 3 10.4094 3H10.2682C10.279 2.90722 10.2844 2.81334 10.2844 2.71875C10.2844 1.19406 8.91188 0 7.15938 0C5.4072 0 4.03438 1.19406 4.03438 2.71875C4.03438 2.81334 4.03989 2.90722 4.05069 3H2.28444C1.0375 3 0 4.0375 0 5.3125V7.38156C0 7.93125 0.211563 8.43437 0.557813 8.8125C0.211563 9.19063 0 9.69375 0 10.2437V13.6875C0 14.9625 1.0375 16 2.28437 16H5.72813C6.27906 16 6.78187 15.7884 7.15906 15.4422C7.56562 15.7875 8.06875 16 8.61875 16H10.4378C11.65 16 13 15.05 13 13.6875V11.9213C13.0928 11.932 13.1867 11.9375 13.2812 11.9375C14.8062 11.9375 16 10.5656 16 8.8125C16 7.05937 14.8062 5.6875 13.2812 5.6875ZM13.2812 10.4375C12.4578 10.4375 12.4759 9.625 11.8684 9.625C11.5281 9.625 11.5 9.90312 11.5 10.2437V13.6875C11.5 14.1362 10.8862 14.5 10.4375 14.5H8.61844C8.27812 14.5 8 14.2219 8 13.8813C8 13.2797 8.78438 13.2912 8.78438 12.4684C8.78438 11.7953 8.05688 11.2497 7.15938 11.2497C6.26188 11.2497 5.53438 11.7953 5.53438 12.4684C5.53438 13.2919 6.34688 13.2738 6.34688 13.8813C6.375 14.2219 6.09687 14.5 5.75625 14.5H2.28437C1.86375 14.5 1.5 14.1375 1.5 13.6875V10.2437C1.5 9.90312 1.77688 9.625 2.11844 9.625C2.72 9.625 2.70844 10.4375 3.53125 10.4375C4.20438 10.4375 4.75 9.71 4.75 8.8125C4.75 7.915 4.20438 7.1875 3.53125 7.1875C2.70781 7.1875 2.72594 8 2.11844 8C1.77688 8 1.5 7.72187 1.5 7.38125V5.3125C1.5 4.8625 1.86375 4.5 2.28437 4.5H5.72813C6.09688 4.5 6.375 4.47187 6.375 4.13125C6.375 3.52969 5.5625 3.54125 5.5625 2.71844C5.5625 2.04531 6.29 1.49969 7.1875 1.49969C8.085 1.49969 8.8125 2.04531 8.8125 2.71844C8.78438 3.54375 8 3.525 8 4.13125C8 4.47187 8.27812 4.5 8.61875 4.5H10.4378C10.8875 4.5 11.5 4.8625 11.5 5.3125V7.38156C11.5 7.72188 11.5281 8 11.8687 8C12.4703 8 12.4588 7.1875 13.2816 7.1875C13.9547 7.1875 14.5003 7.915 14.5003 8.8125C14.5003 9.71 13.9531 10.4375 13.2812 10.4375Z"
        fill={color}
      />
    </svg>
  );
};

export const UsersIcon = ({ color = "#4C4C4C" }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99687 10C11.7909 10 13.2187 8.545 13.2187 6.75C13.2187 4.955 11.7644 3.5 9.99687 3.5C8.20281 3.5 6.775 4.955 6.775 6.75C6.74687 8.54375 8.20312 10 9.99687 10ZM9.99687 5C10.9609 5 11.7456 5.785 11.7456 6.75C11.7456 7.715 10.9594 8.5 9.99687 8.5C9.03437 8.5 8.24687 7.71562 8.24687 6.75C8.24687 5.78438 9.03125 5 9.99687 5ZM16 5C17.3806 5 18.5 3.88063 18.5 2.5C18.5 1.11937 17.3812 0 16 0C14.6194 0 13.5 1.11937 13.5 2.5C13.5 3.88063 14.6187 5 16 5ZM11.5594 11H8.44062C5.9875 11 4 12.8656 4 15.1656C4 15.6281 4.39687 16 4.8875 16H15.1125C15.6031 16 16 15.6281 16 15.1656C16 12.8656 14.0125 11 11.5594 11ZM5.56562 14.5C5.89281 13.3512 7.04562 12.5 8.41375 12.5H11.5594C12.9272 12.5 14.08 13.3512 14.4075 14.5H5.56562ZM17.2469 6H15.3144C14.9144 6 14.5369 6.09491 14.1937 6.2575C14.2125 6.42188 14.2437 6.58125 14.2437 6.75C14.2437 7.80344 13.8444 8.75656 13.2075 9.5H19.4481C19.7531 9.5 20 9.2375 20 8.91562C20 7.30625 18.7687 6 17.2469 6ZM5.74687 6.75C5.74687 6.57972 5.77757 6.41781 5.79716 6.25281C5.45625 6.06562 5.08125 6 4.68437 6H2.7525C1.2325 6 0 7.30625 0 8.91562C0 9.2375 0.246469 9.5 0.550625 9.5H6.785C6.14687 8.75625 5.74687 7.80312 5.74687 6.75ZM4 5C5.38062 5 6.5 3.88063 6.5 2.5C6.5 1.11937 5.38125 0 4 0C2.61937 0 1.5 1.11937 1.5 2.5C1.5 3.88063 2.61937 5 4 5Z"
        fill={color}
      />
    </svg>
  );
};

export const LogoutIcon = ({ color = "#4C4C4C" }) => {
  return (
    <svg
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2222 3.42857V12.5714C18.2222 14.465 16.6926 16 14.8056 16H12.2431C11.7697 16 11.3889 15.6179 11.3889 15.1429C11.3889 14.6693 11.7715 14.2857 12.2431 14.2857H14.8056C15.7451 14.2857 16.5139 13.5143 16.5139 12.5714V3.42857C16.5139 2.48571 15.7451 1.71429 14.8056 1.71429H12.2431C11.7697 1.71429 11.3889 1.33036 11.3889 0.857143C11.3889 0.383571 11.7697 0 12.2431 0H14.8056C16.6918 0 18.2222 1.535 18.2222 3.42857ZM12.2964 7.41429L7.74089 2.55714C7.41701 2.21 6.87604 2.19429 6.53437 2.51786C6.18915 2.84286 6.17135 3.38571 6.49523 3.72857L9.69479 7.14286H0.854167C0.382595 7.14286 0 7.52857 0 8C0 8.47143 0.382595 8.85714 0.854167 8.85714H9.69479L6.49451 12.27C6.17086 12.6149 6.18755 13.1571 6.53121 13.4811C6.69809 13.6357 6.90807 13.7143 7.11806 13.7143C7.34494 13.7143 7.57183 13.6239 7.73982 13.4442L12.2954 8.58707C12.6061 8.25714 12.6061 7.74286 12.2964 7.41429Z"
        fill={color}
      />
    </svg>
  );
};

export const ChangeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 4.00032H9.97188L9.97167 5.75041C9.97167 6.05364 10.1544 6.327 10.4348 6.44325C10.7152 6.55951 11.0373 6.49501 11.2523 6.28065L13.7526 3.78053C14.0455 3.48768 14.0455 3.01268 13.7526 2.71986L11.2523 0.219738C11.0374 0.00538397 10.7151 -0.0590879 10.4348 0.0571364C10.1545 0.173361 9.97188 0.44703 9.97188 0.75017V2.50025H5.5C2.46719 2.50025 0 4.94099 0 8.00052C0 8.4146 0.335938 8.75055 0.75 8.75055C1.16406 8.75055 1.5 8.41616 1.5 8.00052C1.5 5.79416 3.29375 4.00032 5.5 4.00032ZM15.25 7.25048C14.8359 7.25048 14.5 7.58643 14.5 8.00052C14.5 10.2066 12.7056 12.0007 10.5 12.0007H6L6.00036 10.2506C6.00036 9.94739 5.81767 9.67403 5.53723 9.55778C5.25679 9.44152 4.93437 9.50684 4.71875 9.71935L2.21844 12.2195C1.92553 12.5123 1.92553 12.9873 2.21844 13.2801L4.71875 15.7803C4.93366 15.9946 5.25594 16.0591 5.53625 15.9429C5.81656 15.8266 6 15.554 6 15.2509V13.5008H10.5C13.5328 13.5008 16 11.0328 16 8.00052C16 7.588 15.6656 7.25048 15.25 7.25048Z"
        fill={globals.primaryColor}
      />
    </svg>
  );
};

export const OrdersProductionIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 4.5C6.5 5.60313 5.60313 6.5 4.5 6.5C3.39687 6.5 2.5 5.60313 2.5 4.5C2.5 3.39687 3.39687 2.5 4.5 2.5C5.60313 2.5 6.5 3.39687 6.5 4.5ZM8.9375 5.25C8.58125 7.37813 6.73125 9 4.5 9C2.01469 9 0 6.98438 0 4.5C0 2.01469 2.01469 0 4.5 0C6.73125 0 8.58125 1.62188 8.9375 3.75H11.0219C11.1406 3.04063 11.7563 2.5 12.5 2.5H15.5C16.3281 2.5 17 3.17188 17 4V5C17 5.82812 16.3281 6.5 15.5 6.5H12.5C11.7563 6.5 11.1406 5.95937 11.0219 5.25H8.9375ZM4.5 1.5C2.84312 1.5 1.5 2.84312 1.5 4.5C1.5 6.15625 2.84312 7.5 4.5 7.5C6.15625 7.5 7.5 6.15625 7.5 4.5C7.5 2.84312 6.15625 1.5 4.5 1.5ZM12.5 5H15.5V4H12.5V5ZM11.75 8.25C11.75 7.83437 12.0844 7.5 12.5 7.5C12.9156 7.5 13.25 7.83437 13.25 8.25V8.5H16.25C16.6656 8.5 17 8.83438 17 9.25C17 9.66562 16.6656 10 16.25 10H16V14.5C16 15.3281 15.3281 16 14.5 16H10.5C9.67188 16 9 15.3281 9 14.5V10H8.75C8.33438 10 8 9.66562 8 9.25C8 8.83438 8.33438 8.5 8.75 8.5H11.75V8.25ZM10.5 10V14.5H14.5V10H10.5ZM1 10.5C1 10.225 1.22375 10 1.5 10H5.5C6.32812 10 7 10.6719 7 11.5C7 12.3281 6.32812 13 5.5 13H5C5 13.5531 4.55312 14 4 14H2C1.44781 14 1 13.5531 1 13V10.5ZM5 12H5.5C5.775 12 6 11.775 6 11.5C6 11.225 5.775 11 5.5 11H5V12ZM0 15.25C0 14.8344 0.335938 14.5 0.75 14.5H6.25C6.66563 14.5 7 14.8344 7 15.25C7 15.6656 6.66563 16 6.25 16H0.75C0.335938 16 0 15.6656 0 15.25Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const OrdersDeliveryIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 5V3.5C3.5 1.56687 5.06563 0 7 0C8.93437 0 10.5 1.56687 10.5 3.5V5H12.5C13.3281 5 14 5.67188 14 6.5V13C14 14.6562 12.6562 16 11 16H3C1.34312 16 0 14.6562 0 13V6.5C0 5.67188 0.671562 5 1.5 5H3.5ZM5 5H9V3.5C9 2.39531 8.10312 1.5 7 1.5C5.89687 1.5 5 2.39531 5 3.5V5ZM1.5 6.5V13C1.5 13.8281 2.17156 14.5 3 14.5H11C11.8281 14.5 12.5 13.8281 12.5 13V6.5H10.5V8.25C10.5 8.66562 10.1656 9 9.75 9C9.33438 9 9 8.66562 9 8.25V6.5H5V8.25C5 8.66562 4.66563 9 4.25 9C3.83437 9 3.5 8.66562 3.5 8.25V6.5H1.5Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const OrdersFinishedIcon = () => {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7065 0.292923C14.097 0.683487 14.097 1.31776 13.7065 1.70833L5.7077 9.70708C5.31714 10.0976 4.68286 10.0976 4.2923 9.70708L0.292923 5.7077C-0.097641 5.31714 -0.097641 4.68286 0.292923 4.2923C0.683487 3.90173 1.31776 3.90173 1.70833 4.2923L5.00156 7.58241L12.2942 0.292923C12.6847 -0.097641 13.319 -0.097641 13.7096 0.292923H13.7065Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const MapMarkerIcon = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 6.01557C8.5 7.4004 7.38125 8.52205 6 8.52205C4.61875 8.52205 3.5 7.4004 3.5 6.01557C3.5 4.63073 4.61875 3.50908 6 3.50908C7.38125 3.50908 8.5 4.63073 8.5 6.01557ZM6 5.01297C5.44688 5.01297 5 5.46101 5 6.01557C5 6.57013 5.44688 7.01816 6 7.01816C6.55312 7.01816 7 6.57013 7 6.01557C7 5.46101 6.55312 5.01297 6 5.01297ZM12 6.01557C12 8.7539 8.34375 13.629 6.74062 15.6405C6.35625 16.1198 5.64375 16.1198 5.25938 15.6405C3.62813 13.629 0 8.7539 0 6.01557C0 2.69322 2.68625 0 6 0C9.3125 0 12 2.69322 12 6.01557ZM6 1.50389C3.51562 1.50389 1.5 3.52475 1.5 6.01557C1.5 6.40407 1.64031 7.00563 1.97812 7.80771C2.30562 8.58472 2.77063 9.44319 3.30625 10.3111C4.19375 11.7586 5.225 13.1309 6 14.1522C6.775 13.1309 7.80625 11.7586 8.69375 10.3111C9.22813 9.44319 9.69375 8.58472 10.0219 7.80771C10.3594 7.00563 10.5 6.40407 10.5 6.01557C10.5 3.52475 8.48438 1.50389 6 1.50389Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const MobilePhoneIcon = () => {
  return (
    <svg
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.94329 0H1.9874C0.889672 0 0 0.895313 0 2V14C0 15.1047 0.889672 16 1.9874 16H8.94329C10.041 16 10.9307 15.1047 10.9307 14V2C10.9307 0.895313 10.0395 0 8.94329 0ZM9.44014 14C9.44014 14.2757 9.21725 14.5 8.94329 14.5H1.9874C1.71351 14.5 1.49055 14.275 1.49055 14V2C1.49055 1.72431 1.71345 1.5 1.9874 1.5H8.94329C9.21656 1.5 9.44014 1.72438 9.44014 2V14ZM5.46535 12.25C5.05389 12.25 4.72007 12.5856 4.72007 13C4.72007 13.4141 5.05389 13.75 5.46535 13.75C5.8768 13.75 6.21062 13.4141 6.21062 13C6.21062 12.5844 5.87835 12.25 5.46535 12.25Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const EyeClosed = ({ color = "#4C4C4C", size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 113 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M84.3672 84.3673C76.3582 90.4721 66.6061 93.8542 56.5371 94.0188C23.7408 94.0188 5 56.5373 5 56.5373C10.8279 45.6765 18.911 36.1876 28.7071 28.7072M46.6982 20.1802C49.9232 19.4253 53.225 19.0479 56.5371 19.0557C89.3335 19.0557 108.074 56.5373 108.074 56.5373C105.23 61.8578 101.839 66.8669 97.9542 71.483M66.4697 66.4699C65.1829 67.8508 63.6312 68.9584 61.9071 69.7267C60.1829 70.4949 58.3217 70.908 56.4345 70.9413C54.5472 70.9746 52.6726 70.6274 50.9224 69.9205C49.1723 69.2135 47.5824 68.1614 46.2477 66.8267C44.913 65.492 43.8608 63.9021 43.1539 62.1519C42.447 60.4018 42.0998 58.5272 42.1331 56.6399C42.1664 54.7527 42.5795 52.8915 43.3477 51.1673C44.1159 49.4432 45.2236 47.8914 46.6045 46.6047"
        stroke={color}
        strokeWidth="9.37039"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5L108.074 108.074"
        stroke={color}
        strokeWidth="9.37039"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeOpen = ({ color = "#4C4C4C", size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 113 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 42.4815C5 42.4815 23.7408 5 56.5371 5C89.3335 5 108.074 42.4815 108.074 42.4815C108.074 42.4815 89.3335 79.9631 56.5371 79.9631C23.7408 79.9631 5 42.4815 5 42.4815Z"
        stroke={color}
        strokeWidth="9.37039"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.5371 56.5371C64.2998 56.5371 70.5927 50.2442 70.5927 42.4815C70.5927 34.7189 64.2998 28.426 56.5371 28.426C48.7744 28.426 42.4815 34.7189 42.4815 42.4815C42.4815 50.2442 48.7744 56.5371 56.5371 56.5371Z"
        stroke={color}
        strokeWidth="9.37039"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 2H9.25V0.75C9.25 0.335938 9.58438 0 10 0C10.4156 0 10.75 0.335938 10.75 0.75V2H12C13.1031 2 14 2.89531 14 4V14C14 15.1031 13.1031 16 12 16H2C0.895313 16 0 15.1031 0 14V4C0 2.89531 0.895313 2 2 2H3.25V0.75C3.25 0.335938 3.58437 0 4 0C4.41563 0 4.75 0.335938 4.75 0.75V2ZM1.5 14C1.5 14.275 1.72375 14.5 2 14.5H12C12.275 14.5 12.5 14.275 12.5 14V6H1.5V14Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const EllipsisVerticalIcon = () => {
  return (
    <svg
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.84615 12.3077C2.86577 12.3077 3.69231 13.1346 3.69231 14.1538C3.69231 15.1731 2.86577 16 1.84615 16C0.826539 16 0 15.1731 0 14.1538C0 13.1346 0.826539 12.3077 1.84615 12.3077ZM1.84615 6.15385C2.86577 6.15385 3.69231 6.98077 3.69231 8C3.69231 9.01923 2.86577 9.84615 1.84615 9.84615C0.826539 9.84615 0 9.01923 0 8C0 6.98077 0.826539 6.15385 1.84615 6.15385ZM1.84615 3.69231C0.826539 3.69231 0 2.86538 0 1.84615C0 0.826539 0.826539 0 1.84615 0C2.86577 0 3.69231 0.826539 3.69231 1.84615C3.69231 2.86538 2.86577 3.69231 1.84615 3.69231Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9981 6.49905C12.9981 8.85957 12.978 11.5635 14.6464 13.2333L15.7039 14.2917C16.0945 14.6822 16.0945 15.3165 15.7039 15.7071C15.3134 16.0976 14.6791 16.0976 14.2885 15.7071L13.2313 14.649C11.5638 12.9802 8.85829 12.9981 6.49905 12.9981C2.90895 12.9981 0 10.0891 0 6.49905C0 2.90895 2.90895 0 6.49905 0C10.0891 0 12.9981 2.90895 12.9981 6.49905ZM6.49905 10.9984C8.98306 10.9984 10.9984 8.98306 10.9984 6.49905C10.9984 4.01504 8.98306 1.99971 6.49905 1.99971C4.01504 1.99971 1.99971 4.01504 1.99971 6.49905C1.99971 8.98306 4.01504 10.9984 6.49905 10.9984Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7073 1.70711C11.0978 1.31658 11.0978 0.683417 10.7073 0.292893C10.3167 -0.0976311 9.68357 -0.0976311 9.29304 0.292893L1.29304 8.29289L0.585938 9L1.29304 9.70711L9.29304 17.7071C9.68357 18.0976 10.3167 18.0976 10.7073 17.7071C11.0978 17.3166 11.0978 16.6834 10.7073 16.2929L4.41436 10L17.0002 10C17.5525 10 18.0002 9.55229 18.0002 9C18.0002 8.44771 17.5525 8 17.0002 8L4.41437 8L10.7073 1.70711Z"
        fill="#A6A6A6"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6153 2.22013C13.1228 1.71256 13.1228 0.888255 12.6153 0.380681C12.1077 -0.126894 11.2834 -0.126894 10.7758 0.380681L6.5 4.66055L2.22013 0.384741C1.71256 -0.122833 0.888255 -0.122833 0.380681 0.384741C-0.126894 0.892316 -0.126894 1.71662 0.380681 2.22419L4.66055 6.5L0.384741 10.7799C-0.122833 11.2874 -0.122833 12.1117 0.384741 12.6193C0.892316 13.1269 1.71662 13.1269 2.22419 12.6193L6.5 8.33945L10.7799 12.6153C11.2874 13.1228 12.1117 13.1228 12.6193 12.6153C13.1269 12.1077 13.1269 11.2834 12.6193 10.7758L8.33945 6.5L12.6153 2.22013Z"
        fill="#A6A6A6"
      />
    </svg>
  );
};

export const PhoneIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0095 10.0096L11.9407 8.694C11.2717 8.40397 10.4832 8.59685 10.0282 9.16119L9.1707 10.2081C7.77131 9.40338 6.59912 8.2315 5.79567 6.86118L6.84412 6.00242C7.40381 5.54554 7.59694 4.76178 7.3135 4.09459L5.99067 0.985501C5.67317 0.260495 4.88629 -0.135133 4.11972 0.0420555L1.26814 0.700186C0.521879 0.870812 0 1.52613 0 2.29364C0 9.85308 6.14693 16 13.7064 16C14.4739 16 15.1292 15.4784 15.272 14.7334L15.9301 11.879C16.1376 11.1096 15.7376 10.3221 15.0095 10.0096ZM14.497 11.5409L13.8379 14.3975C13.8233 14.4319 13.772 14.5 13.7061 14.5C6.97478 14.5 1.49973 9.02497 1.49973 2.29367C1.49973 2.22823 1.54026 2.17698 1.60423 2.16232L4.45863 1.50357C4.4684 1.50113 4.47865 1.50015 4.48842 1.50015C4.5426 1.50015 4.59339 1.53287 4.61489 1.58168L5.93177 4.65452C5.95521 4.70971 5.93958 4.77415 5.89271 4.81271L4.36879 6.03461C4.09925 6.2553 4.01722 6.63274 4.17053 6.94524C5.20211 9.04619 6.92868 10.7734 9.02995 11.8047C9.31433 11.958 9.72027 11.8759 9.94121 11.6064L11.1915 10.0792C11.2262 10.0353 11.2911 10.0186 11.3453 10.044L14.416 11.3594C14.4751 11.4128 14.5095 11.4784 14.497 11.5409Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 3.75C7.25 3.33437 7.58437 3 8 3C8.41562 3 8.75 3.33437 8.75 3.75V7.6L11.4156 9.375C11.7594 9.60625 11.8531 10.0719 11.5969 10.4156C11.3938 10.7594 10.9281 10.8531 10.5844 10.5969L7.58437 8.59688C7.375 8.48438 7.25 8.25 7.25 7.97188V3.75ZM8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0ZM1.5 8C1.5 11.5906 4.40938 14.5 8 14.5C11.5906 14.5 14.5 11.5906 14.5 8C14.5 4.40938 11.5906 1.5 8 1.5C4.40938 1.5 1.5 4.40938 1.5 8Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const ChevronDownIcon = () => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.29402 6.7071C5.6845 7.09763 6.31862 7.09763 6.7091 6.7071L11.7071 1.70821C12.0976 1.31767 12.0976 0.683441 11.7071 0.292903C11.3167 -0.0976345 10.6825 -0.0976345 10.2921 0.292903L6 4.5857L1.70793 0.296027C1.31745 -0.0945104 0.683327 -0.0945104 0.292854 0.296027C-0.0976181 0.686565 -0.0976181 1.3208 0.292854 1.71134L5.2909 6.71022L5.29402 6.7071Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const CheckIcon = ({ color = "#2b2b2b" }) => {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.82915 0.157287C10.057 0.36835 10.057 0.709644 9.82915 0.900499L3.933 6.82823C3.74316 7.05726 3.40369 7.05726 3.19375 6.82823L0.156985 3.77455C-0.0523283 3.5837 -0.0523283 3.2424 0.156985 3.03134C0.366276 2.82252 0.705751 2.82252 0.91502 3.03134L3.57342 5.70555L9.08989 0.157287C9.29983 -0.052429 9.63931 -0.052429 9.82915 0.157287Z"
        fill={color}
      />
    </svg>
  );
};

export const ArrowLeftIcon = () => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.50309 0.218786C5.67809 0.365659 5.74996 0.556282 5.74996 0.750029C5.74996 0.943776 5.67809 1.1344 5.50309 1.25315L2.56063 4.24998H15.2498C15.6654 4.24998 15.9998 4.58748 15.9998 4.99997C15.9998 5.41247 15.6639 5.74996 15.2498 5.74996H2.56063L5.53028 8.71961C5.82324 9.01257 5.82324 9.4871 5.53028 9.78022C5.23731 10.0733 4.76279 10.0732 4.46967 9.78022L0.219724 5.53028C-0.0732412 5.23731 -0.0732412 4.76279 0.219724 4.46967L4.46967 0.219724C4.76247 -0.0730848 5.23747 -0.0730848 5.50309 0.218786Z"
        fill={globals.primaryColor}
      />
    </svg>
  );
};

export const StoreIcon = () => {
  return (
    <svg
      width="59"
      height="55"
      viewBox="0 0 59 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.2083 24.0625C48.1029 24.0625 46.1693 23.3643 44.6117 22.2148C44.096 21.8389 43.6341 21.4199 43.2152 20.9473C42.7962 21.4092 42.3343 21.8281 41.8294 22.2041C40.2718 23.3643 38.3275 24.0625 36.2113 24.0625C34.1058 24.0625 32.1829 23.375 30.6253 22.1396C30.1097 21.8496 29.637 21.4199 29.2074 20.9473C28.7777 21.4199 28.305 21.8496 27.7894 22.1396C26.2318 23.375 24.3089 24.0625 22.2035 24.0625C20.1087 24.0625 18.1751 23.375 16.6175 22.1396C16.1019 21.8496 15.6292 21.4199 15.2103 20.9473C14.7806 21.4199 14.2972 21.8496 13.7816 22.1396C12.2347 23.375 10.2152 23.9658 8.20746 24.0625C8.20531 24.0625 8.20424 24.0625 8.20209 24.0625C7.76596 24.0625 7.3266 24.0303 6.90014 23.9766C0.957557 23.1816 -1.85421 16.1777 1.32387 11.1504L7.48236 1.41045C8.03021 0.534854 9.00883 0 10.054 0H48.3822C49.4242 0 50.4017 0.534746 50.9495 1.41045L57.1048 11.1504C60.2953 16.1885 57.4701 23.1816 51.5081 23.9766C51.0892 24.0303 50.6595 23.9658 50.2191 24.0625C50.2191 24.0625 50.2191 24.0625 50.2083 24.0625ZM47.222 5.15625H11.2142L5.68305 13.9111C5.06107 14.8887 5.00199 16.1025 5.44027 17.1445C5.86137 18.1328 6.62406 18.7344 7.57904 18.8633C7.79496 18.8955 8.00658 18.9062 8.20209 18.9062C9.47396 18.9062 10.5912 18.3584 11.3753 17.4883C12.3529 16.4141 13.6527 15.791 15.2103 15.791C16.6605 15.791 18.057 16.4141 19.0345 17.4883C19.8187 18.3584 20.9359 18.9062 22.2035 18.9062C23.4818 18.9062 24.5023 18.3584 25.3831 17.4883C26.3607 16.4141 27.7464 15.791 29.2074 15.791C30.6683 15.791 32.054 16.4141 33.0316 17.4883C33.8158 18.3584 34.9437 18.9062 36.2113 18.9062C37.4788 18.9062 38.596 18.3584 39.3802 17.4883C40.3578 16.4141 41.7435 15.791 43.2044 15.791C44.6546 15.791 46.0511 16.4033 47.0286 17.4883C47.8236 18.3584 48.9515 18.9062 50.2083 18.9062C50.4232 18.9062 50.6273 18.8955 50.8421 18.8633C51.8089 18.7344 52.5716 18.1328 52.9906 17.1445C53.431 16.0166 53.3773 14.8994 52.7542 13.9111L47.222 5.15625ZM48.1244 36.0938V27.3281C48.8011 27.4463 49.4994 27.5 50.2083 27.5C50.8099 27.5 51.39 27.457 51.9593 27.3818C52.3246 27.3281 52.8509 27.2422 53.2806 27.1348V48.125C53.2806 51.917 50.1976 55 46.4056 55H12.0306C8.23431 55 5.1556 51.917 5.1556 48.125V27.1348C5.57133 27.2422 5.99994 27.3281 6.44144 27.3818H6.45433C7.01937 27.457 7.60805 27.5 8.20209 27.5C8.92181 27.5 9.62435 27.4355 10.3119 27.3281V36.0938H48.1244ZM48.1244 41.25H10.3119V48.125C10.3119 49.0703 11.0853 49.8438 12.0306 49.8438H46.4056C47.3509 49.8438 48.1244 49.0703 48.1244 48.125V41.25Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const MapDelivery = () => {
  return (
    <svg
      width="67"
      height="34"
      viewBox="0 0 67 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        opacity="0.7"
        x1="66.5"
        y1="1.5"
        x2="66.5"
        y2="31.5"
        stroke="#333333"
        strokeLinecap="round"
      />
      <path
        d="M51 28.9999C51 31.7613 48.7614 33.9999 46 33.9999H5C2.23858 33.9999 0 31.7613 0 28.9999V5.7135C0 2.95208 2.23858 0.713501 5 0.713501H46C48.7614 0.713501 51 2.95208 51 5.7135V28.9999ZM1.18663 27.7559C1.18663 30.5173 3.42521 32.7559 6.18663 32.7559H44.8134C47.5748 32.7559 49.8134 30.5173 49.8134 27.7559V6.95752C49.8134 4.19609 47.5748 1.95752 44.8134 1.95752H6.18663C3.42521 1.95752 1.18663 4.1961 1.18663 6.95752V27.7559Z"
        fill="#343434"
      />
      <path
        d="M44.6399 1.93811H6.35986C3.59844 1.93811 1.35986 4.17669 1.35986 6.93811V27.845C1.35986 30.6064 3.59844 32.845 6.35986 32.845H44.6399C47.4013 32.845 49.6399 30.6064 49.6399 27.845V6.93811C49.6399 4.17669 47.4013 1.93811 44.6399 1.93811Z"
        fill="#242424"
      />
      <path
        d="M49.4229 9.45679C49.9662 9.45679 50.4066 9.01638 50.4066 8.47309V8.47309C50.4066 7.92981 49.9662 7.4894 49.4229 7.4894H44.4964C43.9441 7.4894 43.4964 7.04168 43.4964 6.4894V2.27414C43.4964 1.75592 43.0763 1.33582 42.5581 1.33582V1.33582C42.0399 1.33582 41.6197 1.75592 41.6197 2.27414V6.4894C41.6197 7.04168 41.172 7.4894 40.6197 7.4894H30.3173C29.7651 7.4894 29.3173 7.04168 29.3173 6.4894V2.27414C29.3173 1.75592 28.8972 1.33582 28.379 1.33582V1.33582C27.8608 1.33582 27.4407 1.75592 27.4407 2.27414V6.4894C27.4407 7.04168 26.993 7.4894 26.4407 7.4894H9.46578C8.91349 7.4894 8.46578 7.04168 8.46578 6.4894V2.27414C8.46578 1.75592 8.04568 1.33582 7.52745 1.33582V1.33582C7.00923 1.33582 6.58913 1.75592 6.58913 2.27414V6.4894C6.58913 7.04168 6.14141 7.4894 5.58913 7.4894H1.57696C1.03368 7.4894 0.593262 7.92981 0.593262 8.4731V8.4731C0.593262 9.01638 1.03368 9.45679 1.57696 9.45679H5.58913C6.14141 9.45679 6.58913 9.90451 6.58913 10.4568V16.1078C6.58913 16.6601 6.14141 17.1078 5.58913 17.1078H1.57696C1.03368 17.1078 0.593262 17.5482 0.593262 18.0915V18.0915C0.593262 18.6348 1.03368 19.0752 1.57696 19.0752H5.58913C6.14141 19.0752 6.58913 19.5229 6.58913 20.0752V26.2727C6.58913 26.825 6.14141 27.2727 5.58913 27.2727H1.57696C1.03368 27.2727 0.593262 27.7131 0.593262 28.2564V28.2564C0.593262 28.7997 1.03368 29.2401 1.57696 29.2401H15.7022C16.2545 29.2401 16.7022 29.6878 16.7022 30.2401V32.4399C16.7022 32.9581 17.1223 33.3782 17.6405 33.3782V33.3782C18.1587 33.3782 18.5788 32.9581 18.5788 32.4399V30.2401C18.5788 29.6878 19.0265 29.2401 19.5788 29.2401H26.4407C26.993 29.2401 27.4407 29.6878 27.4407 30.2401V32.4398C27.4407 32.9581 27.8608 33.3782 28.379 33.3782V33.3782C28.8972 33.3782 29.3173 32.9581 29.3173 32.4398V30.2401C29.3173 29.6878 29.7651 29.2401 30.3173 29.2401H49.4229C49.9662 29.2401 50.4066 28.7997 50.4066 28.2564V28.2564C50.4066 27.7131 49.9662 27.2727 49.4229 27.2727H30.3173C29.7651 27.2727 29.3173 26.825 29.3173 26.2727V20.0752C29.3173 19.5229 29.7651 19.0752 30.3173 19.0752H49.4229C49.9662 19.0752 50.4066 18.6348 50.4066 18.0915V18.0915C50.4066 17.5482 49.9662 17.1078 49.4229 17.1078H44.4964C43.9441 17.1078 43.4964 16.6601 43.4964 16.1078V10.4568C43.4964 9.9045 43.9441 9.45678 44.4964 9.45678L49.4229 9.45679ZM26.4407 9.45679C26.993 9.45679 27.4407 9.90451 27.4407 10.4568V10.8614C27.4407 11.4137 26.993 11.8614 26.4407 11.8614H9.46578C8.91349 11.8614 8.46578 11.4137 8.46578 10.8614V10.4568C8.46578 9.90451 8.91349 9.45679 9.46578 9.45679H26.4407ZM8.46578 14.8288C8.46578 14.2765 8.91349 13.8288 9.46578 13.8288H26.4407C26.993 13.8288 27.4407 14.2765 27.4407 14.8288V16.1078C27.4407 16.6601 26.993 17.1078 26.4407 17.1078H9.46578C8.91349 17.1078 8.46578 16.6601 8.46578 16.1078V14.8288ZM9.46578 27.2727C8.91349 27.2727 8.46578 26.825 8.46578 26.2727V20.0752C8.46578 19.5229 8.91349 19.0752 9.46578 19.0752H15.7022C16.2545 19.0752 16.7022 19.5229 16.7022 20.0752V26.2727C16.7022 26.825 16.2545 27.2727 15.7022 27.2727L9.46578 27.2727ZM27.4407 26.2727C27.4407 26.825 26.993 27.2727 26.4407 27.2727H19.5788C19.0265 27.2727 18.5788 26.825 18.5788 26.2727V20.0752C18.5788 19.5229 19.0265 19.0752 19.5788 19.0752H26.4407C26.993 19.0752 27.4407 19.5229 27.4407 20.0752V26.2727ZM41.6197 16.1078C41.6197 16.6601 41.172 17.1078 40.6197 17.1078H30.3173C29.7651 17.1078 29.3173 16.6601 29.3173 16.1078V10.4568C29.3173 9.9045 29.7651 9.45679 30.3173 9.45679H40.6197C41.172 9.45679 41.6197 9.9045 41.6197 10.4568V16.1078Z"
        fill="#343434"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9417 16.064C24.9417 16.064 30.4484 8.96134 30.4484 5.773C30.4484 4.24191 29.8683 2.77352 28.8356 1.69087C27.8029 0.608225 26.4022 0 24.9417 0C23.4813 0 22.0806 0.608225 21.0479 1.69087C20.0152 2.77352 19.4351 4.24191 19.4351 5.773C19.4351 8.96134 24.9417 16.064 24.9417 16.064ZM27.0343 6.98798C27.3109 6.55398 27.4586 6.04374 27.4586 5.52178C27.4587 5.17516 27.3937 4.83192 27.2673 4.51166C27.1408 4.1914 26.9554 3.9004 26.7216 3.65531C26.4878 3.41021 26.2102 3.21583 25.9048 3.08326C25.5993 2.95069 25.2718 2.88253 24.9412 2.88269C24.4433 2.88269 23.9566 3.03747 23.5427 3.32746C23.1287 3.61744 22.806 4.02961 22.6155 4.51184C22.425 4.99407 22.3751 5.52471 22.4722 6.03664C22.5694 6.54857 22.8091 7.01881 23.1612 7.3879C23.5132 7.75698 23.9618 8.00833 24.4501 8.11016C24.9384 8.21199 25.4446 8.15972 25.9046 7.95998C26.3646 7.76023 26.7577 7.42197 27.0343 6.98798Z"
        fill={globals.secondaryColor}
      />
      <path
        d="M24.9424 20.2308C25.7622 20.2308 26.4268 19.5341 26.4268 18.6746C26.4268 17.8151 25.7622 17.1184 24.9424 17.1184C24.1226 17.1184 23.458 17.8151 23.458 18.6746C23.458 19.5341 24.1226 20.2308 24.9424 20.2308Z"
        fill={globals.secondaryColor}
      />
    </svg>
  );
};

export const MapDeliveryFilled = () => {
  return (
    <svg
      width="51"
      height="34"
      viewBox="0 0 51 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51 28.9998C51 31.7612 48.7614 33.9998 46 33.9998H5C2.23858 33.9998 0 31.7612 0 28.9998V5.71338C0 2.95196 2.23858 0.713379 5 0.713379H46C48.7614 0.713379 51 2.95196 51 5.71338V28.9998ZM1.18663 27.7558C1.18663 30.5172 3.42521 32.7558 6.18663 32.7558H44.8134C47.5748 32.7558 49.8134 30.5172 49.8134 27.7558V6.95739C49.8134 4.19597 47.5748 1.9574 44.8134 1.9574H6.18663C3.42521 1.9574 1.18663 4.19598 1.18663 6.9574V27.7558Z"
        fill={globals.secondaryColor}
        fillOpacity="0.4"
      />
      <path
        d="M44.6396 1.93799H6.35965C3.59823 1.93799 1.35965 4.17656 1.35965 6.93799V27.8448C1.35965 30.6063 3.59822 32.8448 6.35965 32.8448H44.6396C47.4011 32.8448 49.6396 30.6063 49.6396 27.8448V6.93799C49.6396 4.17656 47.4011 1.93799 44.6396 1.93799Z"
        fill="#242424"
      />
      <path
        d="M49.4229 9.45691C49.9662 9.45691 50.4066 9.0165 50.4066 8.47322C50.4066 7.92994 49.9662 7.48952 49.4229 7.48952H44.4964C43.9441 7.48952 43.4964 7.0418 43.4964 6.48952V2.27426C43.4964 1.75604 43.0763 1.33594 42.5581 1.33594C42.0399 1.33594 41.6197 1.75604 41.6197 2.27426V6.48952C41.6197 7.0418 41.172 7.48952 40.6197 7.48952H30.3173C29.7651 7.48952 29.3173 7.0418 29.3173 6.48952V2.27426C29.3173 1.75604 28.8972 1.33594 28.379 1.33594C27.8608 1.33594 27.4407 1.75604 27.4407 2.27426V6.48952C27.4407 7.0418 26.993 7.48952 26.4407 7.48952H9.46578C8.91349 7.48952 8.46578 7.0418 8.46578 6.48952V2.27426C8.46578 1.75604 8.04568 1.33594 7.52745 1.33594C7.00923 1.33594 6.58913 1.75604 6.58913 2.27426V6.48952C6.58913 7.0418 6.14141 7.48952 5.58913 7.48952H1.57696C1.03368 7.48952 0.593262 7.92994 0.593262 8.47322C0.593262 9.0165 1.03368 9.45691 1.57696 9.45691H5.58913C6.14141 9.45691 6.58913 9.90463 6.58913 10.4569V16.1079C6.58913 16.6602 6.14141 17.1079 5.58913 17.1079H1.57696C1.03368 17.1079 0.593262 17.5483 0.593262 18.0916C0.593262 18.6349 1.03368 19.0753 1.57696 19.0753H5.58913C6.14141 19.0753 6.58913 19.523 6.58913 20.0753V26.2728C6.58913 26.8251 6.14141 27.2728 5.58913 27.2728H1.57696C1.03368 27.2728 0.593262 27.7132 0.593262 28.2565C0.593262 28.7998 1.03368 29.2402 1.57696 29.2402H15.7022C16.2544 29.2402 16.7022 29.6879 16.7022 30.2402V32.44C16.7022 32.9582 17.1223 33.3783 17.6405 33.3783C18.1587 33.3783 18.5788 32.9582 18.5788 32.44V30.2402C18.5788 29.6879 19.0265 29.2402 19.5788 29.2402H26.4407C26.993 29.2402 27.4407 29.6879 27.4407 30.2402V32.44C27.4407 32.9582 27.8608 33.3783 28.379 33.3783C28.8972 33.3783 29.3173 32.9582 29.3173 32.44V30.2402C29.3173 29.6879 29.7651 29.2402 30.3173 29.2402H49.4229C49.9662 29.2402 50.4066 28.7998 50.4066 28.2565C50.4066 27.7132 49.9662 27.2728 49.4229 27.2728H30.3173C29.7651 27.2728 29.3173 26.8251 29.3173 26.2728V20.0753C29.3173 19.523 29.7651 19.0753 30.3173 19.0753H49.4229C49.9662 19.0753 50.4066 18.6349 50.4066 18.0916C50.4066 17.5483 49.9662 17.1079 49.4229 17.1079H44.4964C43.9441 17.1079 43.4964 16.6602 43.4964 16.1079V10.4569C43.4964 9.90462 43.9441 9.45691 44.4964 9.45691L49.4229 9.45691ZM26.4407 9.45691C26.993 9.45691 27.4407 9.90463 27.4407 10.4569V10.8615C27.4407 11.4138 26.993 11.8615 26.4407 11.8615H9.46578C8.91349 11.8615 8.46578 11.4138 8.46578 10.8615V10.4569C8.46578 9.90463 8.91349 9.45691 9.46578 9.45691H26.4407ZM8.46578 14.8289C8.46578 14.2766 8.91349 13.8289 9.46578 13.8289H26.4407C26.993 13.8289 27.4407 14.2766 27.4407 14.8289V16.1079C27.4407 16.6602 26.993 17.1079 26.4407 17.1079H9.46578C8.91349 17.1079 8.46578 16.6602 8.46578 16.1079V14.8289ZM9.46578 27.2728C8.91349 27.2728 8.46578 26.8251 8.46578 26.2728V20.0753C8.46578 19.523 8.91349 19.0753 9.46578 19.0753H15.7022C16.2544 19.0753 16.7022 19.523 16.7022 20.0753V26.2728C16.7022 26.8251 16.2545 27.2728 15.7022 27.2728L9.46578 27.2728ZM27.4407 26.2728C27.4407 26.8251 26.993 27.2728 26.4407 27.2728H19.5788C19.0265 27.2728 18.5788 26.8251 18.5788 26.2728V20.0753C18.5788 19.523 19.0265 19.0753 19.5788 19.0753H26.4407C26.993 19.0753 27.4407 19.523 27.4407 20.0753V26.2728ZM41.6197 16.1079C41.6197 16.6602 41.172 17.1079 40.6197 17.1079H30.3173C29.7651 17.1079 29.3173 16.6602 29.3173 16.1079V10.4569C29.3173 9.90462 29.7651 9.45691 30.3173 9.45691H40.6197C41.172 9.45691 41.6197 9.90463 41.6197 10.4569V16.1079Z"
        fill={globals.secondaryColor}
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9417 16.064C24.9417 16.064 30.4484 8.96134 30.4484 5.773C30.4484 4.24191 29.8683 2.77352 28.8356 1.69087C27.8029 0.608225 26.4022 0 24.9417 0C23.4813 0 22.0806 0.608225 21.0479 1.69087C20.0152 2.77352 19.4351 4.24191 19.4351 5.773C19.4351 8.96134 24.9417 16.064 24.9417 16.064ZM27.0343 6.98798C27.3109 6.55398 27.4586 6.04374 27.4586 5.52178C27.4587 5.17516 27.3937 4.83192 27.2673 4.51166C27.1408 4.1914 26.9554 3.9004 26.7216 3.65531C26.4878 3.41021 26.2102 3.21583 25.9048 3.08326C25.5993 2.95069 25.2718 2.88253 24.9412 2.88269C24.4433 2.88269 23.9566 3.03747 23.5427 3.32746C23.1287 3.61744 22.806 4.02961 22.6155 4.51184C22.425 4.99407 22.3751 5.52471 22.4722 6.03664C22.5694 6.54857 22.8091 7.01881 23.1612 7.3879C23.5132 7.75698 23.9618 8.00833 24.4501 8.11016C24.9384 8.21199 25.4446 8.15972 25.9046 7.95998C26.3646 7.76023 26.7577 7.42197 27.0343 6.98798Z"
        fill={globals.secondaryColor}
      />
      <path
        d="M24.9423 20.2306C25.7621 20.2306 26.4267 19.5338 26.4267 18.6744C26.4267 17.8149 25.7621 17.1182 24.9423 17.1182C24.1225 17.1182 23.4579 17.8149 23.4579 18.6744C23.4579 19.5338 24.1225 20.2306 24.9423 20.2306Z"
        fill={globals.secondaryColor}
      />
    </svg>
  );
};

export const Upload = ({ color = "#4c4c4c" }) => (
  <svg
    width="14"
    height="20"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8155 5.49481L9.25329 1.6683C8.84856 1.23504 8.30288 0.989161 7.7274 0.982614L2.66653 0.925038C1.46986 0.911424 0.488415 1.91874 0.47412 3.17524L0.319059 16.8244C0.304764 18.0809 1.26304 19.1102 2.4597 19.1239L11.1256 19.2225C12.3223 19.2361 13.3037 18.2287 13.318 16.9722L13.4302 7.10863C13.4371 6.50437 13.2168 5.92597 12.8155 5.49481ZM8.06906 2.19802C8.21998 2.2554 8.36087 2.33806 8.4764 2.46212L12.0386 6.28864C12.155 6.41157 12.2311 6.56175 12.2801 6.72228L8.55977 6.67995C8.26188 6.67656 8.02105 6.41787 8.02461 6.10508L8.06906 2.19802ZM12.2347 16.9599C12.2276 17.5869 11.7357 18.0918 11.1385 18.085L2.47242 17.9864C1.87528 17.9796 1.39497 17.4637 1.4021 16.8367L1.55738 3.18757C1.56452 2.56056 2.05644 2.05567 2.65359 2.06246L6.98664 2.11176L6.94135 6.09275C6.93063 7.03468 7.64976 7.80717 8.54683 7.81738L12.3383 7.86051L12.2347 16.9599ZM7.44416 9.51119C7.44772 9.1984 7.2069 8.93971 6.909 8.93632C6.6111 8.93293 6.36446 9.18608 6.3609 9.49887L6.31181 13.814L4.54912 11.9205C4.44543 11.8091 4.30728 11.7507 4.16849 11.7491C4.0297 11.7475 3.89026 11.8028 3.78406 11.9118C3.56996 12.1315 3.56586 12.4916 3.77492 12.7158L6.45072 15.5902C6.65977 15.8147 7.00269 15.8186 7.21646 15.5989L9.95696 12.7861C10.1711 12.5664 10.1752 12.2063 9.96611 11.9821C9.75706 11.7579 9.41414 11.7537 9.20038 11.9734L7.39507 13.8263L7.44416 9.51119Z"
      fill={color}
    />
  </svg>
);

export const Download = () => (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.375 11.0001C1.16875 11.0001 1 10.8393 1 10.6429C1 10.4465 1.16875 10.2858 1.375 10.2858H9.625C9.83125 10.2858 10 10.4465 10 10.6429C10 10.8393 9.83125 11.0001 9.625 11.0001H1.375ZM5.76484 8.75229C5.61953 8.89069 5.38047 8.89069 5.23516 8.75229L2.23516 5.89515C2.08984 5.75676 2.08984 5.52908 2.23516 5.39069C2.38047 5.25229 2.61953 5.25229 2.76484 5.39069L5.125 7.63845V5.28578V1.3572C5.125 1.16078 5.29375 1.00006 5.5 1.00006C5.70625 1.00006 5.875 1.16078 5.875 1.3572V5.28578V7.63845L8.23516 5.39069C8.38047 5.25229 8.61953 5.25229 8.76484 5.39069C8.91016 5.52908 8.91016 5.75676 8.76484 5.89515L5.76484 8.75229Z"
      fill="#4C4C4C"
      stroke="#4C4C4C"
      strokeWidth="0.5"
    />
  </svg>
);

export const Picture = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.80039 1.79998C2.13664 1.79998 1.60039 2.33623 1.60039 2.99998V11.7525L4.13914 9.21373C4.72414 8.62873 5.67289 8.62873 6.26164 9.21373L8.80039 11.7525L13.7391 6.81372C14.3241 6.22872 15.2729 6.22872 15.8616 6.81372L18.4004 9.35248V2.99998C18.4004 2.33623 17.8641 1.79998 17.2004 1.79998H2.80039ZM1.60039 13.4475V15C1.60039 15.6637 2.13664 16.2 2.80039 16.2H4.35289L7.95289 12.6L5.41414 10.0612C5.29789 9.94497 5.10664 9.94497 4.99039 10.0612L1.60039 13.4475ZM15.0141 7.66123C14.8979 7.54498 14.7066 7.54498 14.5904 7.66123L6.04789 16.2H17.2004C17.8641 16.2 18.4004 15.6637 18.4004 15V11.0475L15.0141 7.66123ZM0.400391 2.99998C0.400391 1.67623 1.47664 0.599976 2.80039 0.599976H17.2004C18.5241 0.599976 19.6004 1.67623 19.6004 2.99998V15C19.6004 16.3237 18.5241 17.4 17.2004 17.4H2.80039C1.47664 17.4 0.400391 16.3237 0.400391 15V2.99998ZM6.40039 4.79998C6.40039 4.64085 6.33718 4.48823 6.22465 4.37571C6.11213 4.26319 5.95952 4.19998 5.80039 4.19998C5.64126 4.19998 5.48865 4.26319 5.37613 4.37571C5.26361 4.48823 5.20039 4.64085 5.20039 4.79998C5.20039 4.95911 5.26361 5.11172 5.37613 5.22424C5.48865 5.33676 5.64126 5.39998 5.80039 5.39998C5.95952 5.39998 6.11213 5.33676 6.22465 5.22424C6.33718 5.11172 6.40039 4.95911 6.40039 4.79998ZM4.00039 4.79998C4.00039 4.32259 4.19003 3.86475 4.5276 3.52718C4.86516 3.18962 5.323 2.99998 5.80039 2.99998C6.27778 2.99998 6.73562 3.18962 7.07318 3.52718C7.41075 3.86475 7.60039 4.32259 7.60039 4.79998C7.60039 5.27737 7.41075 5.7352 7.07318 6.07277C6.73562 6.41033 6.27778 6.59998 5.80039 6.59998C5.323 6.59998 4.86516 6.41033 4.5276 6.07277C4.19003 5.7352 4.00039 5.27737 4.00039 4.79998Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const UserSquare = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="5" fill="#242424" />
    <path
      d="M12.5 12C13.182 12 13.836 11.7366 14.3183 11.2678C14.8005 10.7989 15.0714 10.163 15.0714 9.5C15.0714 8.83696 14.8005 8.20107 14.3183 7.73223C13.836 7.26339 13.182 7 12.5 7C11.818 7 11.164 7.26339 10.6817 7.73223C10.1995 8.20107 9.92857 8.83696 9.92857 9.5C9.92857 10.163 10.1995 10.7989 10.6817 11.2678C11.164 11.7366 11.818 12 12.5 12ZM11.5819 12.9375C9.60313 12.9375 8 14.4961 8 16.4199C8 16.7402 8.26719 17 8.59665 17H16.4033C16.7328 17 17 16.7402 17 16.4199C17 14.4961 15.3969 12.9375 13.4181 12.9375H11.5819Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const UserCircle = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="15" fill="#242424" />
    <path
      d="M17.5714 11.5C17.5714 11.1553 17.5049 10.8139 17.3757 10.4955C17.2465 10.177 17.0571 9.8876 16.8183 9.64384C16.5795 9.40009 16.296 9.20673 15.984 9.07482C15.6721 8.9429 15.3377 8.875 15 8.875C14.6623 8.875 14.3279 8.9429 14.016 9.07482C13.704 9.20673 13.4205 9.40009 13.1817 9.64384C12.9429 9.8876 12.7535 10.177 12.6243 10.4955C12.4951 10.8139 12.4286 11.1553 12.4286 11.5C12.4286 11.8447 12.4951 12.1861 12.6243 12.5045C12.7535 12.823 12.9429 13.1124 13.1817 13.3562C13.4205 13.5999 13.704 13.7933 14.016 13.9252C14.3279 14.0571 14.6623 14.125 15 14.125C15.3377 14.125 15.6721 14.0571 15.984 13.9252C16.296 13.7933 16.5795 13.5999 16.8183 13.3562C17.0571 13.1124 17.2465 12.823 17.3757 12.5045C17.5049 12.1861 17.5714 11.8447 17.5714 11.5ZM11.5714 11.5C11.5714 10.5717 11.9327 9.6815 12.5756 9.02513C13.2186 8.36875 14.0907 8 15 8C15.9093 8 16.7814 8.36875 17.4244 9.02513C18.0673 9.6815 18.4286 10.5717 18.4286 11.5C18.4286 12.4283 18.0673 13.3185 17.4244 13.9749C16.7814 14.6313 15.9093 15 15 15C14.0907 15 13.2186 14.6313 12.5756 13.9749C11.9327 13.3185 11.5714 12.4283 11.5714 11.5ZM9.85714 21.125H20.1429C20.1107 18.9457 18.3696 17.1875 16.2241 17.1875H13.7759C11.633 17.1875 9.89196 18.9457 9.85714 21.125ZM9 21.1879C9 18.4945 11.1375 16.3125 13.7759 16.3125H16.2241C18.8625 16.3125 21 18.4945 21 21.1879C21 21.6363 20.6438 22 20.2045 22H9.79554C9.35625 22 9 21.6363 9 21.1879Z"
      fill="#4c4c4c"
    />
  </svg>
);

export const SuccessIcon = ({ color = "#82D997", size = 28 }) => (
  <svg
    width={size}
    viewBox="0 0 28 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.5216 0.426922C28.1595 0.999807 28.1595 1.92618 27.5216 2.44421L11.0124 18.5338C10.4808 19.1554 9.53032 19.1554 8.94249 18.5338L0.439558 10.2452C-0.146519 9.72717 -0.146519 8.80081 0.439558 8.22792C1.02557 7.66113 1.9761 7.66113 2.56205 8.22792L10.0056 15.4865L25.4517 0.426922C26.0395 -0.142307 26.9901 -0.142307 27.5216 0.426922Z"
      fill={color}
    />
  </svg>
);

export const CheckEdge = () => (
  <svg
    width="24"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4998 7.36V8.004C14.4989 9.5135 14.0101 10.9823 13.1063 12.1913C12.2025 13.4003 10.9321 14.2847 9.4845 14.7127C8.03695 15.1407 6.48984 15.0893 5.07388 14.5662C3.65793 14.0431 2.44901 13.0763 1.62743 11.8099C0.805842 10.5436 0.41561 9.04565 0.51493 7.53942C0.61425 6.0332 1.1978 4.59943 2.17855 3.45196C3.1593 2.30448 4.4847 1.50477 5.95709 1.17211C7.42947 0.839444 8.96994 0.991643 10.3488 1.60601"
      stroke="#82D997"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5001 2.40381L7.50015 9.41081L5.40015 7.31081"
      stroke="#82D997"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorEdge = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
      stroke="#FF502D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1004 5.8999L5.90039 10.0999"
      stroke="#FF502D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.90039 5.8999L10.1004 10.0999"
      stroke="#FF502D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MiniCheck = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.45" clipPpath="url(#clip0_8640_76278)">
      <path
        opacity="0.4"
        d="M5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10ZM7.20703 4.08203L4.70703 6.58203C4.52344 6.76562 4.22656 6.76562 4.04492 6.58203L2.79492 5.33203C2.61133 5.14844 2.61133 4.85156 2.79492 4.66992C2.97852 4.48828 3.27539 4.48633 3.45703 4.66992L4.375 5.58789L6.54297 3.41797C6.72656 3.23438 7.02344 3.23438 7.20508 3.41797C7.38672 3.60156 7.38867 3.89844 7.20508 4.08008L7.20703 4.08203Z"
        fill="#51D9A3"
      />
      <path
        d="M7.20605 3.41797C7.38965 3.60156 7.38965 3.89844 7.20605 4.08008L4.70605 6.58203C4.52246 6.76562 4.22559 6.76562 4.04395 6.58203L2.79395 5.33203C2.61035 5.14844 2.61035 4.85156 2.79395 4.66992C2.97754 4.48828 3.27441 4.48633 3.45605 4.66992L4.37402 5.58789L6.54199 3.41797C6.72559 3.23438 7.02246 3.23438 7.2041 3.41797H7.20605Z"
        fill="#51D9A3"
      />
    </g>
    <defs>
      <clipPath id="clip0_8640_76278">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MiniInfo = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.15"
      d="M5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10ZM5 2.5C5.25977 2.5 5.46875 2.70898 5.46875 2.96875V5.15625C5.46875 5.41602 5.25977 5.625 5 5.625C4.74023 5.625 4.53125 5.41602 4.53125 5.15625V2.96875C4.53125 2.70898 4.74023 2.5 5 2.5ZM4.375 6.875C4.375 6.70924 4.44085 6.55027 4.55806 6.43306C4.67527 6.31585 4.83424 6.25 5 6.25C5.16576 6.25 5.32473 6.31585 5.44194 6.43306C5.55915 6.55027 5.625 6.70924 5.625 6.875C5.625 7.04076 5.55915 7.19973 5.44194 7.31694C5.32473 7.43415 5.16576 7.5 5 7.5C4.83424 7.5 4.67527 7.43415 4.55806 7.31694C4.44085 7.19973 4.375 7.04076 4.375 6.875Z"
      fill="#6F767E"
    />
    <path
      d="M5.46875 2.96875C5.46875 2.70898 5.25977 2.5 5 2.5C4.74023 2.5 4.53125 2.70898 4.53125 2.96875V5.15625C4.53125 5.41602 4.74023 5.625 5 5.625C5.25977 5.625 5.46875 5.41602 5.46875 5.15625V2.96875ZM5 7.5C5.16576 7.5 5.32473 7.43415 5.44194 7.31694C5.55915 7.19973 5.625 7.04076 5.625 6.875C5.625 6.70924 5.55915 6.55027 5.44194 6.43306C5.32473 6.31585 5.16576 6.25 5 6.25C4.83424 6.25 4.67527 6.31585 4.55806 6.43306C4.44085 6.55027 4.375 6.70924 4.375 6.875C4.375 7.04076 4.44085 7.19973 4.55806 7.31694C4.67527 7.43415 4.83424 7.5 5 7.5Z"
      fill="#6F767E"
    />
  </svg>
);

export const PlusCircle = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8560_25789)">
      <path
        d="M6.5 4.75V8.25"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 6.5H8.25"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M6.5 0.5C9.81371 0.5 12.5 3.18629 12.5 6.5C12.5 9.81371 9.81371 12.5 6.5 12.5C3.18629 12.5 0.5 9.81371 0.5 6.5C0.5 3.18629 3.18629 0.5 6.5 0.5Z"
      stroke="#3D734A"
    />
    <defs>
      <clipPath id="clip0_8560_25789">
        <path
          d="M0 6.5C0 2.91015 2.91015 0 6.5 0C10.0899 0 13 2.91015 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const WhatsApp = ({ color = "#4c4c4c" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2027 1.74375C9.08036 0.61875 7.58571 0 5.99732 0C2.71875 0 0.0508929 2.66786 0.0508929 5.94643C0.0508929 6.99375 0.324107 8.01696 0.84375 8.91964L0 12L3.15268 11.1723C4.02054 11.6464 4.99821 11.8955 5.99464 11.8955H5.99732C9.27321 11.8955 12 9.22768 12 5.94911C12 4.36071 11.325 2.86875 10.2027 1.74375ZM5.99732 10.8938C5.10804 10.8938 4.2375 10.6554 3.47946 10.2054L3.3 10.0982L1.43036 10.5884L1.92857 8.76429L1.81071 8.57679C1.31518 7.78929 1.05536 6.88125 1.05536 5.94643C1.05536 3.22232 3.27321 1.00446 6 1.00446C7.32054 1.00446 8.56071 1.51875 9.49286 2.45357C10.425 3.38839 10.9982 4.62857 10.9955 5.94911C10.9955 8.67589 8.72143 10.8938 5.99732 10.8938ZM8.70804 7.19196C8.56071 7.11696 7.82946 6.75804 7.69286 6.70982C7.55625 6.65893 7.45714 6.63482 7.35804 6.78482C7.25893 6.93482 6.975 7.26696 6.88661 7.36875C6.80089 7.46786 6.7125 7.48125 6.56518 7.40625C5.69196 6.96964 5.11875 6.62679 4.54286 5.63839C4.39018 5.37589 4.69554 5.39464 4.97946 4.82679C5.02768 4.72768 5.00357 4.64196 4.96607 4.56696C4.92857 4.49196 4.63125 3.76071 4.50804 3.46339C4.3875 3.17411 4.26429 3.21429 4.17321 3.20893C4.0875 3.20357 3.98839 3.20357 3.88929 3.20357C3.79018 3.20357 3.62946 3.24107 3.49286 3.38839C3.35625 3.53839 2.97321 3.89732 2.97321 4.62857C2.97321 5.35982 3.50625 6.06696 3.57857 6.16607C3.65357 6.26518 4.62589 7.76518 6.11786 8.41071C7.06071 8.81786 7.43036 8.85268 7.90179 8.78304C8.18839 8.74018 8.78036 8.42411 8.90357 8.07589C9.02679 7.72768 9.02679 7.43036 8.98929 7.36875C8.95446 7.30179 8.85536 7.26429 8.70804 7.19196Z"
        fill={color}
        fillOpacity="1"
      />
    </svg>
  );
};

export const Interrogation = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 0.5C26.1127 0.5 33.5 7.8873 33.5 17C33.5 26.1127 26.1127 33.5 17 33.5C7.8873 33.5 0.5 26.1127 0.5 17C0.5 7.8873 7.8873 0.5 17 0.5Z"
      stroke="#6161FF"
      strokeOpacity="0.3"
    />
    <path
      d="M16.4582 12.5183C15.354 12.5183 14.4582 13.4956 14.4582 14.7001C14.4582 14.9001 14.3082 15.0637 14.1248 15.0637C13.9415 15.0637 13.7915 14.9001 13.7915 14.7001C13.7915 13.0933 14.9853 11.791 16.4582 11.791H17.1248C18.5978 11.791 19.7915 13.0933 19.7915 14.7001C19.7915 15.5024 19.4457 16.2547 18.8582 16.7365L17.5915 17.7728C17.2978 18.0137 17.1248 18.391 17.1248 18.791V19.0637C17.1248 19.2637 16.9748 19.4274 16.7915 19.4274C16.6082 19.4274 16.4582 19.2637 16.4582 19.0637V18.791C16.4582 18.1615 16.729 17.5683 17.1915 17.191L18.4582 16.1547C18.8769 15.8115 19.1248 15.2728 19.1248 14.7001C19.1248 13.4956 18.229 12.5183 17.1248 12.5183H16.4582ZM16.2915 21.2456C16.2915 21.1009 16.3442 20.9622 16.438 20.8599C16.5317 20.7576 16.6589 20.7001 16.7915 20.7001C16.9241 20.7001 17.0513 20.7576 17.1451 20.8599C17.2388 20.9622 17.2915 21.1009 17.2915 21.2456C17.2915 21.3902 17.2388 21.529 17.1451 21.6313C17.0513 21.7335 16.9241 21.791 16.7915 21.791C16.6589 21.791 16.5317 21.7335 16.438 21.6313C16.3442 21.529 16.2915 21.3902 16.2915 21.2456Z"
      fill="#6161FF"
    />
  </svg>
);

export const InfoCircleGrey = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
      fill="#2B2B2B"
    />
    <path
      d="M6.3125 3.5625C6.3125 3.25078 6.06172 3 5.75 3C5.43828 3 5.1875 3.25078 5.1875 3.5625V6.1875C5.1875 6.49922 5.43828 6.75 5.75 6.75C6.06172 6.75 6.3125 6.49922 6.3125 6.1875V3.5625ZM5.75 9C5.94891 9 6.13968 8.92098 6.28033 8.78033C6.42098 8.63968 6.5 8.44891 6.5 8.25C6.5 8.05109 6.42098 7.86032 6.28033 7.71967C6.13968 7.57902 5.94891 7.5 5.75 7.5C5.55109 7.5 5.36032 7.57902 5.21967 7.71967C5.07902 7.86032 5 8.05109 5 8.25C5 8.44891 5.07902 8.63968 5.21967 8.78033C5.36032 8.92098 5.55109 9 5.75 9Z"
      fill="#6F767E"
    />
  </svg>
);

export const InfoCircleGreen = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
      fill="#51D9A3"
      fillOpacity="0.15"
    />
    <path
      d="M8.54604 4.2543C8.61802 4.32775 8.61802 4.44858 8.54604 4.52202L5.38819 7.74414C5.31621 7.81758 5.19779 7.81758 5.12581 7.74414L3.45401 6.03831C3.38203 5.96487 3.38203 5.84404 3.45401 5.77059C3.52599 5.69715 3.64441 5.69715 3.71639 5.77059L5.257 7.34256L8.28366 4.2543C8.35564 4.18086 8.47406 4.18086 8.54604 4.2543Z"
      fill="#51D9A3"
      stroke="#51D9A3"
      strokeWidth="0.5"
    />
  </svg>
);

export const InfoCircle = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM8 4C7.725 4 7.5 4.225 7.5 4.5V8.5C7.5 8.775 7.725 9 8 9C8.275 9 8.5 8.775 8.5 8.5V4.5C8.5 4.225 8.275 4 8 4ZM8.75 11C8.75 10.8011 8.67098 10.6103 8.53033 10.4697C8.38968 10.329 8.19891 10.25 8 10.25C7.80109 10.25 7.61032 10.329 7.46967 10.4697C7.32902 10.6103 7.25 10.8011 7.25 11C7.25 11.1989 7.32902 11.3897 7.46967 11.5303C7.61032 11.671 7.80109 11.75 8 11.75C8.19891 11.75 8.38968 11.671 8.53033 11.5303C8.67098 11.3897 8.75 11.1989 8.75 11Z"
      fill="#6F767E"
    />
  </svg>
);

export const Link = () => (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7361 5.00022C12.68 4.11031 12.68 2.66866 11.7361 1.77876C10.7922 0.888852 9.26305 0.888852 8.31915 1.77876L7.8925 2.181C7.77546 2.29134 7.77546 2.47288 7.8925 2.58323C8.00954 2.69358 8.2021 2.69358 8.31915 2.58323L8.74579 2.181C9.45372 1.51357 10.6015 1.51357 11.3094 2.181C12.0174 2.84842 12.0174 3.93055 11.3094 4.59798L8.95722 6.81385C8.25118 7.4795 7.10528 7.4795 6.39736 6.81385C5.72529 6.18023 5.68754 5.16574 6.30863 4.48941L6.40868 4.38084C6.51817 4.2616 6.50496 4.08183 6.37848 3.97861C6.25199 3.87538 6.06132 3.88783 5.95183 4.00708L5.85178 4.11565C5.02303 5.01802 5.074 6.37067 5.96882 7.2143C6.91084 8.10243 8.43997 8.10243 9.38198 7.2143L11.7361 5.00022ZM1.48527 5.00022C0.541367 5.89012 0.541367 7.33177 1.48527 8.22168C2.42918 9.11158 3.9583 9.11158 4.90221 8.22168L5.32885 7.81944C5.4459 7.70909 5.4459 7.52755 5.32885 7.4172C5.21181 7.30685 5.01925 7.30685 4.90221 7.4172L4.47556 7.81944C3.76764 8.48687 2.61985 8.48687 1.91192 7.81944C1.20399 7.15201 1.20399 6.06988 1.91192 5.40245L4.26413 3.18659C4.97017 2.52094 6.11607 2.52094 6.824 3.18659C7.49606 3.8202 7.53382 4.8347 6.91273 5.51102L6.81267 5.61959C6.70318 5.73884 6.71639 5.9186 6.84288 6.02183C6.96936 6.12506 7.16003 6.1126 7.26952 5.99335L7.36958 5.88478C8.19833 4.98242 8.14736 3.62976 7.25253 2.78613C6.30674 1.89445 4.7795 1.89445 3.8356 2.78257L1.48527 5.00022Z"
      fill="#426CDA"
      stroke="#426CDA"
      strokeWidth="0.5"
    />
  </svg>
);

export const ConnectStep = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="10" fill="#292929" />
    <path
      d="M15.7778 10.125C15.7778 9.91875 15.9528 9.75 16.1667 9.75H17.3698C17.4476 9.75 17.5205 9.77109 17.5861 9.81328L18.3615 10.3125C18.5535 10.4367 18.7795 10.5023 19.008 10.5023L20.8333 10.5C21.0472 10.5 21.2222 10.6688 21.2222 10.875V13.125C21.2222 13.3313 21.0472 13.5 20.8333 13.5H16.1667C15.9528 13.5 15.7778 13.3313 15.7778 13.125V10.125ZM15 10.125V13.125C15 13.7461 15.5226 14.25 16.1667 14.25H20.8333C21.4774 14.25 22 13.7461 22 13.125V10.875C22 10.2539 21.4774 9.75 20.8333 9.75H19.0056C18.9278 9.75 18.8549 9.72891 18.7892 9.68672L18.0163 9.18984C17.8243 9.06562 17.5983 9 17.3698 9H16.1667C15.5226 9 15 9.50391 15 10.125ZM16.1667 16.5H17.3698C17.4476 16.5 17.5205 16.5211 17.5861 16.5633L18.4101 17.093C18.5705 17.1961 18.7576 17.25 18.9497 17.25H20.8358C21.0497 17.25 21.2247 17.4187 21.2247 17.625V19.875C21.2247 20.0813 21.0497 20.25 20.8358 20.25H16.1691C15.9552 20.25 15.7802 20.0813 15.7802 19.875V16.875C15.7802 16.6687 15.9552 16.5 16.1691 16.5H16.1667ZM15 16.875V19.875C15 20.4961 15.5226 21 16.1667 21H20.8333C21.4774 21 22 20.4961 22 19.875V17.625C22 17.0039 21.4774 16.5 20.8333 16.5H18.9472C18.9083 16.5 18.8719 16.4883 18.8403 16.4695L18.0163 15.9398C17.8243 15.8156 17.6007 15.75 17.3698 15.75H16.1667C15.5226 15.75 15 16.2539 15 16.875ZM8.77778 9.5625C8.77778 9.35625 8.60278 9.1875 8.38889 9.1875C8.175 9.1875 8 9.35625 8 9.5625V18.375C8 18.9961 8.52257 19.5 9.16667 19.5H13.8333V18.75H9.16667C8.95278 18.75 8.77778 18.5813 8.77778 18.375V12.75H13.8333V12H8.77778V9.5625Z"
      fill="#6F767E"
    />
  </svg>
);

export const ConnectStep1 = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="10" fill="#292929" />
    <path
      d="M21 18H14V8H18.5844L21 10.4156V18ZM22 10L19 7H14H13V8V18V19H14H21H22V18V10ZM9 11H8V12V22V23H9H16H17V22V20H16V22H9V12H12V11H9Z"
      fill="#6F767E"
    />
  </svg>
);

export const ConnectStep2 = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="10" fill="#292929" />
    <path
      d="M15.0385 8.53846V8H13.9615V8.53846V14.4615H8.03846H7.5V15.5385H8.03846H13.9615V21.4615V22H15.0385V21.4615V15.5385H20.9615H21.5V14.4615H20.9615H15.0385V8.53846Z"
      fill="#6F767E"
    />
  </svg>
);

export const Ticket = ({ color = "#6F767E" }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.847253 9.75721C0.596285 9.50624 0.614718 9.08229 0.888501 8.8085L8.8081 0.888909C9.08188 0.615125 9.50583 0.596692 9.7568 0.84766L10.4601 1.55094C10.0004 2.22044 10.033 3.10379 10.5818 3.65252C11.1305 4.20124 12.0138 4.23385 12.6833 3.7742L13.3866 4.47747C13.6376 4.72844 13.6191 5.15239 13.3454 5.42618L5.42577 13.3458C5.15199 13.6196 4.72803 13.638 4.47707 13.387L0.847253 9.75721ZM0.434774 8.35478C-0.111245 8.9008 -0.14824 9.75166 0.352278 10.2522L3.98209 13.882C4.48261 14.3825 5.33348 14.3455 5.8795 13.7995L13.7991 5.8799C14.3451 5.33388 14.3821 4.48302 13.8816 3.9825L12.9401 3.04102C12.8267 2.92759 12.6235 2.97193 12.4998 3.09567C12.0899 3.50557 11.4525 3.53329 11.0767 3.15754C10.701 2.7818 10.7287 2.14439 11.1386 1.73449C11.2623 1.61075 11.3067 1.4076 11.1933 1.29417L10.2518 0.352685C9.75126 -0.147832 8.90039 -0.110838 8.35437 0.435182L0.434774 8.35478ZM8.23063 3.28129C8.17046 3.22112 8.08668 3.18949 7.99772 3.19336C7.90876 3.19722 7.82191 3.23627 7.75627 3.30191C7.69064 3.36755 7.65159 3.4544 7.64772 3.54336C7.64385 3.63232 7.67548 3.71609 7.73565 3.77626C7.79582 3.83643 7.8796 3.86806 7.96856 3.86419C8.05751 3.86032 8.14436 3.82127 8.21 3.75564C8.27564 3.69 8.31469 3.60315 8.31856 3.51419C8.32242 3.42523 8.29079 3.34145 8.23063 3.28129ZM9.13808 4.18874C9.07791 4.12857 8.99413 4.09694 8.90518 4.10081C8.81622 4.10468 8.72937 4.14373 8.66373 4.20936C8.59809 4.275 8.55904 4.36185 8.55518 4.45081C8.55131 4.53977 8.58294 4.62355 8.6431 4.68371C8.70327 4.74388 8.78705 4.77551 8.87601 4.77164C8.96497 4.76778 9.05182 4.72873 9.11746 4.66309C9.18309 4.59745 9.22214 4.5106 9.22601 4.42164C9.22988 4.33269 9.19825 4.24891 9.13808 4.18874ZM10.0249 5.57054C10.0905 5.50491 10.1296 5.41806 10.1335 5.3291C10.1373 5.24014 10.1057 5.15636 10.0455 5.09619C9.98537 5.03603 9.90159 5.0044 9.81263 5.00826C9.72367 5.01213 9.63682 5.05118 9.57118 5.11682C9.50554 5.18246 9.4665 5.26931 9.46263 5.35826C9.45876 5.44722 9.49039 5.531 9.55056 5.59117C9.61073 5.65134 9.6945 5.68297 9.78346 5.6791C9.87242 5.67523 9.95927 5.63618 10.0249 5.57054ZM10.953 6.00365C10.8928 5.94348 10.809 5.91185 10.7201 5.91572C10.6311 5.91959 10.5443 5.95863 10.4786 6.02427C10.413 6.08991 10.374 6.17676 10.3701 6.26572C10.3662 6.35468 10.3978 6.43845 10.458 6.49862C10.5182 6.55879 10.602 6.59042 10.6909 6.58655C10.7799 6.58268 10.8667 6.54364 10.9324 6.478C10.998 6.41236 11.037 6.32551 11.0409 6.23655C11.0448 6.14759 11.0132 6.06381 10.953 6.00365Z"
      fill={color}
    />
  </svg>
);
